import { AppMode } from '@customTypes/Generic'

export const cleanHashFromUrl = (mode: AppMode) => {
  const firstLocationHash = '#/'

  if (window.location.hash !== firstLocationHash && mode === AppMode.NORMAL) {
    window.location.hash = firstLocationHash
  }
}
